/**
 * 답안 제출 API 서비스
 */

import axiosInstance from '../config/axios';
import { AnswerValue } from '../types/answer';

/**
 * 답안 제출 요청 데이터
 */
export interface SubmitAnswerRequest {
  workbook_name: string;
  page: number;
  problem_number: string;
  attempt_number: number;
  user_answer: string;
  answer_image_url?: string | null;
}

/**
 * 답안 제출 결과
 */
export interface SubmitResult {
  success: boolean;
  is_correct: boolean;
  correct_answer: string;
  user_answer: string;
  score: number;
  combo: number;
  combo_multiplier: number;
  total_score: number;
  message: string;
  page_completed: boolean;
}

/**
 * 답안 제출 및 채점
 *
 * POST /api/v1/student/submit
 *
 * @param data - 제출 데이터
 * @returns 채점 결과
 */
export const submitAnswer = async (
  data: SubmitAnswerRequest
): Promise<SubmitResult> => {
  try {
    const response = await axiosInstance.post<SubmitResult>('/student/submit', data);
    return response.data;
  } catch (error: any) {
    console.error('Failed to submit answer:', error);
    throw error;
  }
};

/**
 * AnswerValue를 문자열로 변환
 *
 * @param answer - 답안 (string | string[] | Blob)
 * @returns 문자열 답안
 */
export const formatAnswerForSubmit = (answer: AnswerValue): string => {
  if (Array.isArray(answer)) {
    // S타입: 배열 → 쉼표로 연결
    return answer.join(',');
  }

  if (answer instanceof Blob) {
    // E/T타입: Blob → 이미지 URL (향후 업로드 구현)
    return '';
  }

  return String(answer);
};
